export { default } from './TermsAndConditionsLayout';
